import { formatEvent } from "@/lib/event/format-event";
import { out } from "@/lib/output/out";
import type { ApiOutputs } from "@/lib/api/api-outputs";

export function consumeSessionEvents(
  events: ApiOutputs["sessions"]["events"]["items"],
  cursor: number,
  quiet: boolean | undefined,
  baseUrl: string,
): number {
  for (const event of events) {
    cursor = Math.max(cursor, event.sequence);
    if (quiet) {
      continue;
    }
    const line = formatEvent(event, baseUrl);
    if (line) {
      out.line(line);
    }
  }
  return cursor;
}
